import React from 'react'
import { Span, Flex, Input, Label, Range } from '@fareye/ui'
import { tripDetailConstant } from '../../../utility/constants'
import { isEmpty, formatMs } from '@fareye/utils'

interface IOverspeedListing {
  data: any
  dataLength: number
  onSelect: (id: any) => void
  id: { [key: string]: number }
  overspeedSlider: any
  currOverspeedSlider: any
  setCurrOverspeedSlider: any
}

export const OverspeedListing = ({
  data,
  dataLength,
  onSelect,
  id,
  overspeedSlider,
  currOverspeedSlider,
  setCurrOverspeedSlider
}: IOverspeedListing) => {
  const [overspeedValue, setOverspeedValue] = React.useState(
    currOverspeedSlider
  )

  return (
    <Flex column p={2}>
      {dataLength && (
        <Flex p={2} column style={{ marginBottom: '20px' }}>
          <Label
            variant={'h6'}
            style={{ fontWeight: 700, marginBottom: '24px' }}
          >
            Speed
          </Label>
          {dataLength > 1 && (
            <Range
              formatLabel={(value: any) => formatMs(value)}
              maxValue={overspeedSlider.max}
              minValue={overspeedSlider.min}
              value={overspeedValue}
              onChange={(value: any) => {
                setOverspeedValue(value)
              }}
              onChangeComplete={(value: any) => setCurrOverspeedSlider(value)}
            />
          )}
        </Flex>
      )}
      <Flex justifyContentSpaceAround>
        <Label />
        <Label>{tripDetailConstant.landmark}</Label>
        <Label>{tripDetailConstant.time}</Label>
      </Flex>

      {!isEmpty(data) ? (
        data
          .sort((a: any, b: any) => {
            const diff1 = a.speed
            const diff2 = b.speed
            return diff2 - diff1
          })
          .map((item: any, index: number) => (
            <Flex
              key={index}
              justifyContentSpaceBetween
              style={{ marginBottom: '20px' }}
            >
              <Input
                type="radio"
                checked={item.id === id.overspeedInstanceId}
                onChange={() => {
                  onSelect({ overspeedInstanceId: item.id })
                }}
              />
              <Span
                style={{ flex: 3, maxWidth: '230px' }}
                dangerouslySetInnerHTML={{
                  __html: item.startLandmark.split('/').join('<br/>')
                }}
              />
              <Flex
                p={2}
                style={{ flex: 2, maxWidth: '110px' }}
                justifyContentSpaceAround
                column
              >
                <Span>{`${item.speed} km/ph`}</Span>
              </Flex>
            </Flex>
          ))
      ) : (
        <Span p={2} style={{ margin: 'auto' }}>
          No Data
        </Span>
      )}
    </Flex>
  )
}
